import React from 'react';
import PropTypes from 'prop-types';
import { Input } from 'antd';
import { useTheme } from '../../../contexts/ThemeContext';

const CVVInput = ({
  value,
  onChange,
  placeholder = '123',
  style,
  className,
  ...props
}) => {
  const { theme } = useTheme();

  const formatCVV = (input) => {
    // Remove tudo que não é dígito
    const cleaned = input.replace(/\D/g, '');
    
    // Limita a 4 dígitos (para cartões que podem ter 3 ou 4 dígitos)
    const limited = cleaned.slice(0, 4);
    
    return limited;
  };

  const handleChange = (e) => {
    const inputValue = e.target.value;
    const formattedValue = formatCVV(inputValue);
    
    // Chama onChange com o valor limpo (apenas números)
    onChange && onChange(formattedValue);
  };

  return (
    <Input
      value={value || ''}
      onChange={handleChange}
      placeholder={placeholder}
      type="password"
      maxLength={4}
      style={{
        backgroundColor: theme.background,
        color: theme.textSecondary,
        borderColor: theme.border,
        ...style
      }}
      className={className}
      {...props}
    />
  );
};

CVVInput.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
  placeholder: PropTypes.string,
  style: PropTypes.object,
  className: PropTypes.string,
};

export default CVVInput; 